import styled from "styled-components";
import { pxToRem } from "../../styles/utils";
import type { StatusTone } from "./StatusDot.types";

export const Dot = styled.span<{ $tone: StatusTone }>`
  display: inline-block;
  width: ${pxToRem(7.5)};
  height: ${pxToRem(7.5)};
  flex: 0 0 auto;
  border-radius: 50%;
  background: ${({ $tone, theme }) => {
    if ($tone === "success") return theme.colors.success;
    if ($tone === "warning") return theme.colors.warning;
    if ($tone === "danger") return theme.colors.danger;
    if ($tone === "inactive") return theme.colors.inkBorder;
    return theme.colors.brand;
  }};
`;
